define(
    'LNRS/Components/Charts/map',["jquery", "d3", "scrollMagic", "mustache", "text!LNRS/Components/Charts/Templates/MapPopupTemplate.html"],
    function ($, d3, ScrollMagic, mustache, toolTipTemplate) {
        "use strict";

        function Map(scope, mapInfo, mapWrapperId, mapData) {
            
            var chartId = "#" + mapWrapperId;
            var controller = new ScrollMagic.Controller();
            var isMobile = $(window).width() < 810; 
            var tooltipWidth = 300;
            var tooltipHeight = 100;

            var dataset = {                
                scaleBlockNames: ["Poor","Fair","Good","Excellent"],
                scaleBorders: mapInfo.mapRange
            };

            new ScrollMagic.Scene({ triggerElement: chartId, duration: 200 })
                .on('enter', function () {
                    doMap(mapWrapperId, mapData, dataset);
                    this.enabled(false);
                }).addTo(controller);

            function initMap(gDiv, mapData, dataset) {

                dataset.svgWidth = $("#"+gDiv).width();
                dataset.svgHeight = dataset.svgWidth*2/3 - 10;
    
                if (isMobile) {
//                    $("#"+gDiv).css('min-height','320px');
                }
                
                //fix IE11
                d3.select("#"+gDiv)
                .append('canvas')
                .attr('width', dataset.svgWidth )
                .attr('height', dataset.svgHeight )
                .attr('style','width:100%;display:block;visibility:hidden;');
        
                var svg = d3.select("#"+gDiv)
                    .append('svg')
                    .attr('viewBox', '0,0,'+ dataset.svgWidth + ','+ dataset.svgHeight );
        
                //var tts = document.getElementsByClassName("tooltip");
    
                //var mChilds = $(mapInfo.mapSvg).children()[0].children;
                // create scaling group
                if (isMobile) {
                    svg.append('g')
                    .attr('id','map-g')
                    .attr('transform', 'translate(20,10) scale(.9)');
                } else {
                    svg.append('g')
                    .attr('id','map-g')
                    .attr('transform', 'translate(40,26) scale(.9)');                    
                }
                
                // add map
                $("#"+gDiv +" svg #map-g").append(jQuery.parseXML(mapInfo.mapSvg).documentElement);
                //$("#"+gDiv +" svg #map-g")
                //.append(mapSvg.documentElement);
                
                //document.getElementById(gDiv).insertBefore(mapInfo.mapSvg.documentElement, tts[0]);
                $('body').append('<div id="map-overlay"></div>');

                $("#" + gDiv).append('<div class="map-tooltip"></div>');
            }

            function zoomPan() {
                var ctransform = d3.event.transform;
                var myBox = d3.select("svg #allStates");
                    
                myBox.transition().duration(300).attr("transform", ctransform);
            }

            function findState(data, id) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i]["id"] == id) {
                        return i;
                    }
                }

                return null;
            }
            
            function lookupValue(data, dataset) {
                
                var val = data.value,
                    valInt = parseInt(data.value,10);
                
                if (valInt < dataset.scaleBorders[0]) {
                    val = dataset.scaleBorders[0];
                } else if (valInt > dataset.scaleBorders[dataset.scaleBorders.length - 1]) {
                    val = dataset.scaleBorders[dataset.scaleBorders.length - 1];
                }

                return val;
            }            
            
            function doMap(gDiv, mapData, dataset) {
                
                var j;
                
                
                dataset.minData = dataset.scaleBorders[0];
                dataset.maxData = dataset.scaleBorders[dataset.scaleBorders.length - 1];
                
                
                var zoom = d3.zoom(zoomPan)
                            .scaleExtent([1, 5])
                            .translateExtent([[-(dataset.svgWidth/2), -(dataset.svgHeight/2)],[(dataset.svgWidth*3/2), (dataset.svgHeight*3/2)]])
                            .on("zoom", zoomPan );
                            //
                            
                    var svg = d3.select("#" + gDiv + " svg")
                        .call(zoom)
                        .on("wheel.zoom", null);
                    //var svgHeight = svg.height();
                    
                //////////////////////////////////////////    
                //Append a defs (for definition) element 
                    var defs = d3.select("#" + gDiv + " svg").append("defs");
                    var linearGradient = defs.append("linearGradient")
                        .attr("id", "linear-gradient");

                    // init gradients
    var gradData = [],
        domData = [],
        rangeData = [];
        
        //gradient start
        var jVal,jCol;
        var jEnd = mapInfo.colorSchemeColors.length - 1;
        gradData.push( {offset: "0%", color: mapInfo.colorSchemeColors[jEnd]} );
        domData.push(dataset.minData);
        rangeData.push(mapInfo.colorSchemeColors[jEnd]);
        
        // gradient middle points
        for (j = 1; j < jEnd; j++){
            jVal = j/jEnd;
            jCol = mapInfo.colorSchemeColors[jEnd - j];
            gradData.push( {offset: jVal*100 + "%", color: jCol} );
            domData.push(dataset.minData + (dataset.maxData - dataset.minData)*jVal);
            rangeData.push(jCol);
              
        }
        
        // gradient end
        gradData.push( {offset: "100%", color: mapInfo.colorSchemeColors[0]} );
        domData.push(dataset.maxData);
        rangeData.push(mapInfo.colorSchemeColors[0]);
        
        linearGradient.selectAll("stop")
            .data(gradData)
            .enter().append("stop")
            .attr("offset", function(d) { return d.offset; })
            .attr("stop-color", function(d) { return d.color; });
        //var color =  d3.scaleLinear;
        var color2 = d3.scaleLinear()
            .domain(domData)
            .range(rangeData)
            .interpolate(d3.interpolateHcl);
                   
                    var x = d3.scaleLinear()
                        .domain([1, 10])
                        //.range([500, 1000]);
                        .range([dataset.minData, dataset.maxData]);

                    $("#" + gDiv + ' svg path').attr('class','states');
                    $.each( $("#" + gDiv + ' .states'), function(i){
                        var sId = $(this).attr('id');
                        var sData = mapData[findState(mapData,sId)];
                        for (j = 0; j < dataset.scaleBorders.length - 1; j++) {
                            if (sData && sData.value < dataset.scaleBorders[j]) {
                                break;
                            }
                        }
                        d3.select("#"+sId)
                            .transition()
                            .delay(50*i)
                            .attr("fill", color2(dataset.scaleBorders[j]));
                    });

                    d3.selectAll('.states')
/*
                        .attr('class', "states")
                        .data(mapData)
                        .attr("fill", function(d) { 
                            for (j = 0; j < dataset.scaleBorders.length; j++) {
                                if (d.value < dataset.scaleBorders[j]) {
                                    break;
                                }
                            }
                            return color2(dataset.scaleBorders[j]); 
                        })
*/
                        .on("mouseenter", function(d){
                            if (isTooltipOpen(gDiv)) {
                                return;
                            }

                            var mId = $(this).attr('id');
                            var mState = findState(mapData, mId);

                            if (!isMobile) {
                                loadTooltip(gDiv, this, d3.event);
                            }
                            
                            var myClass = $("#" + gDiv + ' #' + mapData[mState].id).attr('class');
                            $("#" + gDiv + ' #' + mapData[mState].id).attr('class',myClass + " hover-on");
                            
                            var myClass = $("#" + gDiv + ' .labs.lab' + mapData[mState].id).attr('class');
                            $("#" + gDiv + ' .labs.lab' + mapData[mState].id).attr('class',myClass + " hover-on");
                        })
                        .on("mouseout", function(d) {
                            if (isTooltipOpen(gDiv)) {
                                return;
                            }

                            var mId = $(this).attr('id');
                            var mState = findState(mapData, mId);
                            // hide hover
                            var myClass = $("#" + gDiv + ' #' + mapData[mState].id).attr('class');
                            myClass = myClass.replace(" hover-on", "");
                            $("#" + gDiv + ' #' + mapData[mState].id).attr('class', myClass);
                            
                            myClass = $("#" + gDiv + ' .labs.lab' + mapData[mState].id).attr('class');
                            myClass = myClass.replace(" hover-on", "");
                            $("#" + gDiv + ' .labs.lab' + mapData[mState].id).attr('class', myClass);
                            // hide tooltip
                             $("#" + gDiv + " .tooltip-map")
                                .css("opacity",0)
                                .css("top",0)
                                .css("left",0);
                            
                            $("#" + gDiv + " .map-tooltip").css("display", "none");    
                        })
                        .on("mousemove", function(d){
                            if (isTooltipOpen(gDiv)) {
                                return;
                            }

                            var mId = $(this).attr('id');
                            var mState = findState(mapData, mId);
                            $("#" + gDiv + " .tooltip-map").html(mapData[mState].countryName);
                            var offset = $("#" + gDiv).offset(),
                                xTooltipPosition = (d3.event.pageX - offset.left + 60 )+"px",
                                yTooltipPosition = (d3.event.pageY - offset.top - 20)+"px";
                                
                            if ((d3.event.offsetX - (tooltipWidth / 2)) >= ($("#" + gDiv).width() / 2)) {
                                xTooltipPosition = (d3.event.pageX - offset.left - tooltipWidth - 30 )+"px";
                            }
                            
                            if ((d3.event.offsetY - tooltipHeight) >= ($("#" + gDiv + " svg").height() / 2)) {
                                yTooltipPosition = (d3.event.pageY - offset.top - 2 * tooltipHeight) + "px";
                            }                                                                
                            
                            $("#" + gDiv + " .map-tooltip")
                                .css("left", xTooltipPosition)
                                .css("top", yTooltipPosition)
                                .css("opacity", 1)
                                .css("display", "block");

                        },this)
                        .on("click touchend", function(){
                            d3.event.stopImmediatePropagation();
                            
                            if (isTooltipOpen(gDiv)) {
                                return;
                            }
                            
                            var mId = $(this).attr('id');
                            var self = this;
                            var clickEvent = d3.event;

                            //reset highlight and tooltip
                            $("#" + gDiv + ' path.states').attr('class','states');
                            $("#" + gDiv + ' .map-tooltip').removeClass("open");
                            $.each($("#" + gDiv + ' .labs'), function(){
                                var sClass = $(this).attr('class');
                                sClass = sClass.replace(' state-open','');
                                $(this).attr('class',sClass);
                            });

                            
                            // open overlay only on small screen sizes
                            if ($(window).width() < 768) {
                                $('body').addClass("map-open");
                            }
                            // open tooltip
                            $("#" + gDiv + ' .map-tooltip').addClass('open');
                            // highlight selected state
                            $(this).attr('class','states active');
                            
                            $("#" + gDiv + ' .labs.lab' + mId).attr('class','labs lab' + mId + " state-open");

                            setTimeout(function() {
                                loadTooltip(gDiv, self, clickEvent);     
                                
                                zoomReset.select('circle').attr("opacity", 0.9);
                                zoomReset.select('#rshape').attr("opacity", 0.9);

                                // get bBox of selected state and center it in view
                                // x, y, width, height
                                var scale = 2,
                                    dx,
                                    dy;

                                //PR is special case
//                                if (mId == "PR") {
//                                    dx = -700;
//                                    dy = -390;
//                                } else {
                                    var mbb = d3.select("#"+mId).node().getBBox();
                                    dx = 960/2 - mbb.width/2 - mbb.x - 300;
                                    dy =   50-mbb.y;
//                                }
                                // scale and move map
                                var transform = d3.zoomIdentity
                                    .scale(scale)
                                    .translate(dx, dy);
                                    svg.call(zoom.transform, transform);
                                    
                                if (!isMobile) {
                                    var xTooltipPosition = Math.abs(dx) + (500 - Math.abs(dx));
                                    var yTooltipPosition = Math.abs(Math.abs(dy) + (100 - Math.abs(dy)));                                    
                                    
                                    $("#" + gDiv + " .map-tooltip")
                                        .css("left", xTooltipPosition  + "px")
                                        .css("top", yTooltipPosition  + "px");
                                }                                
                            }, 150);                            
                        });

                        // close tooltip and reset map
                        $("#" + gDiv).on('click touchstart', '.map-tooltip .close', function(e){
                            e.stopPropagation();
                            setTimeout(function() {
                                    $('.map-tooltip').removeClass('open').css("display", "none");
                                    $('body').removeClass('map-open');
                                    resetMap(mapWrapperId);
                                    //svg.call(zoom.transform, d3.zoomIdentity);  
                                    var stateZ = d3.zoomTransform(svg.node());

                                    if (stateZ.k == 1) {
                                        zoomReset.select('circle').attr("opacity", 0.0);
                                        zoomReset.select('#rshape').attr("opacity", 0.0);
                                    }
                                },
                                150);
                        });
                        
                        // open/close accordion items
                        $("#" + gDiv).on('mouseup', '.map-tooltip .lvl1', function(e){
                            e.stopImmediatePropagation();
                           
                            var isCurrentAccordionOpen  = $(this).hasClass('open');
                            $(".lvl1").removeClass('open');
                    
                            if (isCurrentAccordionOpen) {
                                $(this).removeClass('open');
                            } else {
                                $(this).addClass('open');
                            }
                        }); 
                 
                    // now we are ready 
                    // make legend bar
                    // max width 700, centered at bottom
                    var legY = dataset.svgHeight - 20;
                    if (dataset.svgWidth > 740) {
                        var legWidth = 700,
                        legX = (dataset.svgWidth - 700)/2;
                    } else {
                        var legX = 40,
                            legWidth = dataset.svgWidth - legX*2;
                    }
                    
                    var g = d3.select("#" + mapWrapperId + " svg").append("g")
                        .attr('class', "key")
                        .attr('style','opacity: 0')
                        .attr("transform", "translate("+legX+","+legY+")");

                    g.append("rect")
                        .attr("height", 8)
                        .attr("x", x.domain()[0])
                        .attr("width", legWidth )
                        .attr("fill", "url(#linear-gradient)");

                    g.append("text")
                        .attr('class', "caption")
                        .attr("x", x.domain()[0])
                        .attr("y", -6)
                        .attr("fill", "#000")
                        .attr("font-size", "12")
                        .attr("text-anchor", "start")
                        .attr("font-weight", "bold")
                        .text(mapInfo.legendTitle);

                // to create legend use custom element
                    var lScale = d3.scaleLinear()
                        //.domain([500, 1000])
                        .domain([dataset.minData, dataset.maxData])
                        .range([0, legWidth]);



                    var lgd = g.append("g")
                        .attr('class', "legend");
                    for (j=0;j<dataset.scaleBorders.length;j++) {
                        lgd.append("line")
                            .attr('x1', lScale(dataset.scaleBorders[j]))
                            .attr('x2', lScale(dataset.scaleBorders[j]))
                            .attr('y1', '0')
                            .attr('y2', '6')
                            .attr('stroke',"#000");
                            
                        lgd.append('text')
                            .attr('fill','#000')
                            .attr('font-size', '12')
                            .attr('y','18')
                            .attr('x',lScale(dataset.scaleBorders[j]))
                            .text(dataset.scaleBorders[j]);
                    }
                            
                            
                g.transition()
                    .duration(3000)
                    .attr('style','opacity: 1');

                    // end legend


                // add circles with values 
                    var lgdgroups = lgd.selectAll('datapoints')
                        .data(mapData)
                        .enter()
                        .append('g')
                        .attr("opacity", 0)
                        .attr('class',function(d){ 
                                return ('labs lab' + d.id ); 
                            });
                        
                        lgdgroups.append('circle')
                            .attr('r', 20)
                            .attr('cx', function(d){
                                var val = lookupValue(d, dataset);
                                
                                return lScale(val); 
                            })
                            .attr('cy', 0)
                            .attr('fill', '#000');

                        lgdgroups.append('text')
                                .text( function(d){
                                    return d.value;
                                })
                                .attr('fill', '#fff')
                                .attr('x', function(d){ 
                                    var val = lookupValue(d, dataset);
                                    return lScale(val); 
                                })
                                .attr('y', 5)
                                .attr('text-anchor','middle');
                                
                                
                // add zoom buttons
                    var zoomIn = svg.append("g")
                            .attr("id","zoom-in");
                            
                        zoomIn.append("circle")
                            .attr("cx", 40)
                            .attr("cy", 80)
                            .attr("r", 17)
                            .attr("fill", "#fff")
                            .attr("opacity",0.9)
                            .on("mouseover",function(d){
                                d3.select(this).style("cursor", "pointer"); 
                            })
                            .on("mouseout",function(d){
                                d3.select(this).style("cursor", "default"); 
                            })
                            .on("click touchstart",function() {
                                resetMap(gDiv);
                                zoom.scaleBy(svg, 1.5);
                                zoomReset.select('circle').attr("opacity", 0.9);
                                zoomReset.select('#rshape').attr("opacity", 0.9);
                            });
                        zoomIn.append("text")
                            .text("+")
                            .attr("text-anchor","middle")
                            .attr("x", 40)
                            .attr("y", 93)
                            .attr("fill","#666666")
                            .attr("font-size","35")
                            .attr("style","pointer-events: none;");
                            
                    var zoomReset = svg.append("g")
                            .attr("id","zoom-out");
                        zoomReset.append("circle")
                            .attr("cx", 40)
                            .attr("cy", 200)
                            .attr("r", 17)
                            .attr("fill", "#fff")
                            .attr("opacity",0.0)
                            .on("mouseover",function(d){
                                d3.select(this).style("cursor", "pointer"); 
                            })
                            .on("mouseout",function(d){
                                d3.select(this).style("cursor", "default"); 
                            })
                            .on("click touchstart",function(){
                                resetMap(gDiv);
                                //svg.transition().duration(250).call(zoom.transform, d3.zoomIdentity);
                                svg.call(zoom.transform, d3.zoomIdentity);
                                //zoom.scaleTo(svg, 1).translateTo(0,0);
                                zoomReset.select('circle').attr("opacity", 0.0);
                                zoomReset.select('#rshape').attr("opacity", 0.0);
                            });
/*
                        zoomReset.append("text")
                            .text("x")
                            .attr("text-anchor","middle")
                            .attr("x", 41)
                            .attr("y", 212)
                            .attr("fill","#000")
                            .attr("font-size","36")
                            ;
*/
                        zoomReset.append("path")
                            .attr("id", "rshape")  
                            .attr("d", "M394.074,35.558c-0.942-0.606-1.832-1.27-2.782-1.863l-0.004,0.004c-0.046-0.027-0.09-0.062-0.137-0.09 L360.774,82.41l-0.981,1.574l-29.23,46.961l-0.082,0.133l0,0l-0.086,0.137c41.726,25.973,66.637,70.758,66.637,119.794 c0,77.762-63.266,141.031-141.027,141.031c-77.766,0-141.031-63.27-141.031-141.031c0-25.895,7.258-50.989,20.394-72.754 c1.18-1.93,2.332-3.867,3.61-5.746l27.058,30.32l15.844,17.894l0.023-0.117l0.133,0.148L217.762,56.77l11.297-51.618l-0.054,0.004 l0.039-0.164L91.133,19.824L9.004,28.558l0.078,0.086l-0.196,0.024L61.18,85.117C22.012,131.137,0,189.898,0,251.008 c0,141.16,114.844,256,256.004,256c141.156,0,255.996-114.84,255.996-256C512,163.164,467.95,82.93,394.074,35.558z")            .attr(null, "opacity", 1) 
                            .attr("fill", "#666666")
                            .attr("style","pointer-events: none;")
                            .attr("transform","scale(.040) translate(750,4750)")
                            .attr("opacity",0.0);    
                            
                    var zoomOut = svg.append("g")
                            .attr("id","zoom-out");
                        zoomOut.append("circle")
                            .attr("cx", 40)
                            .attr("cy", 140)
                            .attr("r", 17)
                            .attr("fill", "#fff")
                            .attr("opacity",0.9)
                            .on("mouseover",function(d){
                                d3.select(this).style("cursor", "pointer"); 
                            })
                            .on("mouseout",function(d){
                                d3.select(this).style("cursor", "default"); 
                            })
                            .on("click touchstart",function() {
                                resetMap(gDiv);
                                var stateZ = d3.zoomTransform(svg.node());
                                
                                if (stateZ.k == 1) {
                                    zoomReset.select('circle').attr("opacity", 0.0);
                                    zoomReset.select('#rshape').attr("opacity", 0.0);
                                } else {
                                    zoom.scaleBy(svg, .75);
                                    zoomReset.select('circle').attr("opacity", 0.9);
                                    zoomReset.select('#rshape').attr("opacity", 0.9);
                                }
                            });
                        zoomOut.append("text")
                            .text("-")
                            .attr("text-anchor","middle")
                            .attr("x", 40)
                            .attr("y", 151)
                            .attr("fill","#666666")
                            .attr("font-size","40")
                            .attr("style","pointer-events: none;");
            }

            function loadTooltip(gDiv, scope, clickEvent) {
                var mId = $(scope).attr('id');

                var selectedCountry = mapData.filter(function(country) {
                    return mId === country.id;
                })[0];

                if (!selectedCountry) {
                    return;
                }

                var metaData = $.map(selectedCountry.mapDataValues, function( val, i ) {
                    return {
                        Title: mapInfo.mapDataHeader[i].Key,
                        Text: mapInfo.mapDataHeader[i].Value,
                        Value: val.Value
                    }
                });

                var options = {
                    CountryCode: selectedCountry.id,
                    CountryName: selectedCountry.countryName,
                    DataList: metaData
                };

                var tooltipMarkup = mustache.render(toolTipTemplate, options);

                $("#" + gDiv + ' .map-tooltip').html(tooltipMarkup);
                
                if (isMobile) {
                    var screenWidth = $(window).width();
                    
                    $("#" + gDiv + " .map-tooltip").css("left", (screenWidth/2 - tooltipWidth/2 )+"px")
                        .css("top", clickEvent.y + "px").css("bottom", "auto");
                } else {
                    var offset = $("#" + gDiv).offset();

                    var xTooltipPosition = ((clickEvent.pageX ? clickEvent.pageX : clickEvent.changedTouches[0].clientX) - offset.left + 60 )+"px",
                        yTooltipPosition = ((clickEvent.pageY ? clickEvent.pageY : clickEvent.changedTouches[0].clientY) - offset.top - 20)+"px";

                    if ((clickEvent.offsetX - (tooltipWidth / 2)) >= ($("#" + gDiv).width() / 2)) {
                        xTooltipPosition = (clickEvent.pageX - offset.left - tooltipWidth - 30 )+"px";
                    }
                                
                    if ((clickEvent.offsetY - tooltipHeight) >= ($("#" + gDiv + " svg").height() / 2)) {
                        yTooltipPosition =
                            (clickEvent.pageY - offset.top - 2 * tooltipHeight) + "px";
                    }
                                
                    $("#" + gDiv + " .map-tooltip")
                        .css("left", xTooltipPosition)
                        .css("top", yTooltipPosition)
                        .css("opacity", 1)
                        .css("display", "block");                    
                }

                if ($("#" + gDiv + " .map-tooltip").css("display") !== "block") {
                    $("#" + gDiv + " .map-tooltip").css("display", "block");
                }

                $('.lvl1').removeClass('open');
            }

            function isTooltipOpen(gDiv) {
                return $("#" + gDiv + " .map-tooltip").hasClass("open");
            }

            function resetMap(gDiv) {
                $("#" + gDiv + ' path.states').attr('class','states');
                $("#" + gDiv + ' .map-tooltip').removeClass("open");
                
                var tmpClass = $("#" + gDiv + ' .labs.state-open').attr('class');
                if (tmpClass) {
                    tmpClass = tmpClass.replace(' state-open','');
                    $("#" + gDiv + ' .labs.state-open').attr('class', tmpClass);
                }
            }

            initMap(mapWrapperId, mapData, dataset);
        }

        return function initMap(args) {
            return args.IsExperienceEditorEditing ? null : new Map(
                args.scope,
                args.mapInfo,
                args.mapWrapperId,
                args.mapData);
        };
    });
